import React, { PropsWithChildren } from 'react';
import { Spin } from 'antd';
import type { SpinProps } from 'antd';

export const LoadingWrapper = ({
  children,
  loading = false,
  size,
}: PropsWithChildren<{
  loading: boolean;
  /** Spinner size, passed through to the underlying spinner. */
  size?: SpinProps['size'];
}>) => {
  if (loading) {
    return <Spin size={size}>{children}</Spin>;
  }

  return children;
};
